export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11417.1b7833de.jpg";